<script>
  import { createEventDispatcher } from 'svelte';
  import { contact } from 'ionicons/icons/index.mjs';
  const dispatch = createEventDispatcher();
  export let page;
  export let account;
  export let referrer;
  let popover = false;
</script>

<ul class="tab">
  <li class="tab-item {page == "Account" ? "active" : ""}">
    <a href="/account">
      Account
    </a>
  </li>
  <li class="tab-item {page == "Subscription" ? "active" : ""}">
    <a href="/account/subscription">
      Store
    </a>
  </li>
  <li class="tab-item tab-action">
    <div class="dropdown dropdown-right">
      <button class="btn btn-link" on:click={function (e) {
        e.currentTarget.blur();
        popover = !popover;
      }}>
        <i class="svg">{@html contact.md}</i>
      </button>
    {#if popover}
      <div class="menu">
      <li class="menu-item"><a class="btn btn-link" href={referrer}>Home</a></li>
      {#if account}
        <li class="menu-item">
          <form action="/account/logout" method="POST">
            <input type="hidden" name="returnUrl" value={window.location.pathname} />
            <input type="submit" class="btn btn-link" value="Sign Out" />
          </form>
        </li>
      {:else}
        <li class="menu-item"><button class="btn btn-link" on:click={ function (e) {
            e.currentTarget.blur();
            popover = false;
            dispatch("message", {
              type: "modal"
            });
          }}>Sign In</button></li>
      {/if}
      </div>
    {/if}
    </div>
  </li>
</ul>

<style>
  .tab .tab-item {
    text-align: center;
    min-width: 20%;
  }
  .tab .tab-item a {
    margin: 0;
  }
  .tab .tab-action {
    text-align: right;
  }
  .dropdown .menu {
    display: block;
		box-shadow: 0 0.2rem 0.5rem rgba(48, 55, 66, 0.3);
		border: 0.05rem solid #dadee4;
    width: 100%;
    padding: 0.4rem 0;
    margin: 0;
    text-align: left;
  }
  .btn .svg {
    height: 1.2rem;
    width: 1.2rem;
  }
  .menu .menu-item > a {
    padding: 0.25rem 0.4rem;
    color: #00ab5f;
  }
  .menu-item a:hover, .menu-item a:focus, .menu-item a:active {
    background: white;
    color: #00a55c;
  }
</style>